import { render, staticRenderFns } from "./PayrollPivotDetail.vue?vue&type=template&id=1ba578e3&scoped=true"
import script from "./PayrollPivotDetail.vue?vue&type=script&lang=js"
export * from "./PayrollPivotDetail.vue?vue&type=script&lang=js"
import style0 from "./PayrollPivotDetail.vue?vue&type=style&index=0&id=1ba578e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba578e3",
  null
  
)

export default component.exports